export default "__VITE_ASSET__Bg3h572s__"